/**
 * Created by piotr.pozniak@thebeaverhead.com on 15/12/2022
 */

import React from "react";
import { IntegrationStatus } from "../consts/integrations";
import ExpandableAlert from "./ExpandableAlert";
import PermissionsAlert from "./Integration/PermissionsAlert";
import { useIntegrationsStore } from "../../../hooks/redux/integrations";
import { Link } from "react-router-dom";
import FlatAlert from "./FlatAlert";

/**
 *
 * @param integration
 * @returns {*}
 */
const isDisabled = (integration) => {
  return integration && integration.disabled_date;
};
/**
 *
 * @param integration
 * @returns {boolean}
 */
const hasPermissionError = (integration) => {
  return (
    integration &&
    integration.status === IntegrationStatus.permissionsRevoked &&
    !integration.state
  );
};

/**
 *
 * @param integration
 * @returns {boolean}
 */
const hasSyncError = (integration) => {
  return (
    integration &&
    integration.status === IntegrationStatus.syncError &&
    !integration.state
  );
};

/**
 *
 * @param integration
 * @returns {boolean}
 */
export const hasIntegrationErrors = (integration) => {
  return hasSyncError(integration) || hasPermissionError(integration);
};

/**
 * IntegrationIssueNotification component displays notifications for integration issues.
 *
 * @param {object} props
 * @param {string} props.integration_uuid - The UUID of the integration to check.
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const IntegrationIssueNotification = (props) => {
  const { integration_uuid } = props;
  // get integration model from the collection from integrations hook store based on the integration_uuid
  const { integrations } = useIntegrationsStore();
  const integration = integrations.collection.find(
    (integration) => integration.uuid === integration_uuid
  );

  const syncError = hasSyncError(integration) ? (
    <ExpandableAlert
      icon={"error"}
      errorLevel={"danger"}
      header={
        <span>
          Last sync failed.{" "}
          <Link to={"/integrations"} className={"alert-link"}>
            Go to Integrations
          </Link>
          .
        </span>
      }
      body={
        <span>
          You may experience outdated data due to:{" "}
          {integration.last_error_message}
        </span>
      }
    />
  ) : null;

  const permissionsError = hasPermissionError(integration) ? (
    <PermissionsAlert integration={integration} />
  ) : null;

  const disabledIntegrationAlert = isDisabled(integration) ? (
    <FlatAlert icon={"error"} errorLevel={"danger"}>
      You may experience outdated data because the integration this widget uses
      has been disabled due to plan downgrade.{" "}
      <Link to={"/billing"} class={"alert-link"}>
        Manage your subscription
      </Link>
      .
    </FlatAlert>
  ) : null;

  // if there are errors, return the wrapped in a div, otherwise return null

  return syncError || permissionsError || disabledIntegrationAlert ? (
    <div className={"overlapping-alert-container"}>
      {syncError}
      {permissionsError}
      {disabledIntegrationAlert}
    </div>
  ) : null;
};

export default IntegrationIssueNotification;
